import blue from "@material-ui/core/colors/blue";
import green from "@material-ui/core/colors/green";
import orange from "@material-ui/core/colors/orange";
import red from "@material-ui/core/colors/red";

import styles from "static/colors.scss";

const background = {
  0: "#121212",
  1: "#1E1E1E",
  2: "#232323",
  3: "#252525",
  4: "#272727",
  6: "#2C2C2C",
  8: "#2F2F2F",
  12: "#333333",
  16: "#353535",
  24: "#383838",
  default: "#121212",
  paper: "#2C2C2C",
};

const darkTheme = {
  palette: {
    type: "dark",
    background: {
      ...background,
    },
    iconColor: "#879096",
    primary: {
      light: "#FFB7A6",
      main: "#FF9880",
      dark: "#FF7959",
      contrastText: "#000000",
    },
    secondary: {
      light: styles.darkSecondary,
      main: styles.darkSecondary,
      dark: styles.darkSecondary,
      contrastText: "#000000",
    },
    tertiary: {
      light: orange[100],
      main: orange[200],
      dark: orange[500],
    },
    success: {
      light: green[200],
      main: green[200],
      dark: green[400],
    },
    error: {
      light: red[200],
      main: red[200],
      dark: red[400],
    },
    text: {
      primary: styles.darkTextPrimary,
      secondary: styles.darkTextSecondary,
      tertiary: styles.darkTextTertiary,
      disabled: styles.darkTextDisabled,
    },
    divider: "rgba(255, 255, 255, 0.06)",
    dividerFaint: "rgba(255, 255, 255, 0.03)",
    dividerMinimal: "rgba(255, 255, 255, 0.01)",
  },
  typography: {
    h1: {
      fontSize: "2.2rem",
      lineHeight: "2.2rem",
      fontWeight: 400,
      color: styles.darkTextPrimary,
    },
    h2: {
      fontWeight: 300,
      fontSize: "1.4rem",
      marginBottom: 20,
      color: styles.darkTextPrimary,
    },
    h3: {
      fontWeight: 300,
      fontSize: "1.2rem",
      marginBottom: 15,
      color: styles.darkTextPrimary,
    },
    h4: {
      fontWeight: 300,
      fontSize: "1.1rem",
      color: styles.darkTextPrimary,
    },
    h6: {
      fontWeight: 300,
      fontSize: "1rem",
      color: styles.darkTextPrimary,
    },
    body1: {
      fontWeight: 300,
      fontSize: "1rem",
      lineHeight: "1rem",
      color: styles.darkTextPrimary,
    },
    body2: {
      fontWeight: 300,
      fontSize: "1rem",
      lineHeight: "1rem",
      color: styles.darkTextSecondary,
    },
    a: {
      color: blue[200],
    },
    button: {
      fontWeight: 500,
    },
    allVariants: {
      color: styles.darkTextPrimary,
    },
  },
  overrides: {
    MuiFilledInput: {
      root: {
        backgroundColor: background[8],
      },
      underline: {
        "&&&:before": {
          borderBottom: `2px solid ${styles.darkTextDisabled}`,
        },
        "&&&:after": {
          borderBottom: `2px solid ${styles.darkTextPrimary}`,
        },
      },
    },
  },
};

export default darkTheme;
